<template>
  <section class="video-intro">
    <p class="video-paragraph">
      Check out this effective storytelling example from last year's national champion:
    </p>
    <div class="video-wrapper">
      <iframe
        class="video-frame optanon-category-C0003"
        :data-src="variables[siteVariant].iframeUrl"
        frameborder="0"
        allowfullscreen
        allow="autoplay; fullscreen; picture-in-picture"
        title="home video"
        type="text/plain"
      ></iframe>
    </div>
  </section>
</template>

<script setup>
defineProps({
  siteVariant: String,
});

const variables = {
  acura: {
    iframeUrl: 'https://player.vimeo.com/video/1063629090?dnt=1&texttrack=en-x-autogen',
  },
  honda: {
    iframeUrl: 'https://player.vimeo.com/video/1064752667?dnt=1&texttrack=en-x-autogen',
  },
};
</script>

<style lang="scss" scoped>
.video-intro {
  background-color: $AC_Navy;
  padding: 10px 16px 40px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 0;
    height: 12vw;
    width: 100%;
    background: linear-gradient( rgb(3, 6, 27, 0), rgba(3, 6, 27, 1));
  }

  @media (min-width: 641px) {
    padding-top: 75px;
    padding-bottom: 75px;
  }

  @media (min-width: 1025px) {
    padding-top: 100px;
    padding-bottom: 130px;
  }

  .video-paragraph {
    font-size: clamp(17px, 53px, 3.5vw);
    font-weight: 300;
    color: $AC_White;
    line-height: 1.4;
    text-transform: uppercase;
    max-width: 1390px;
    width: 100%;
    margin: 0 auto 15px;

    @media (min-width: 1025px) {
      margin-bottom: 40px;
    }
  }
}

.video-wrapper {
  position: relative;
  padding-bottom: 56%;
  height: 0;
  width: 100%;
  max-width: 1640px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid $AC_White;
  border-radius: 3px;

  @media (min-width: 641px) {
    border-radius: 10px;
  }

  @media (min-width: 1691px) {
    padding-bottom: 49%;
    width: 87%;
  }
}

.video-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
